import { createContext, useContext, type ReactNode } from 'react';

export interface CanvasFullscreenContextValue {
  isFullscreen: boolean;
  enterFullscreen: () => Promise<void>;
  exitFullscreen: () => Promise<void>;
  fullscreenOnEngage: boolean;
}

const CanvasFullscreenContext =
  createContext<CanvasFullscreenContextValue | null>(null);

export function CanvasFullscreenProvider({
  value,
  children,
}: {
  value: CanvasFullscreenContextValue;
  children: ReactNode;
}): ReactNode {
  return (
    <CanvasFullscreenContext.Provider value={value}>
      {children}
    </CanvasFullscreenContext.Provider>
  );
}

export function useCanvasFullscreenContext(): CanvasFullscreenContextValue {
  const ctx = useContext(CanvasFullscreenContext);
  if (!ctx) {
    throw new Error(
      'useCanvasFullscreenContext must be used within CanvasFullscreenProvider',
    );
  }
  return ctx;
}
